/**
 * Returns true if a variant group is active (selectable) on the checkout.
 *
 * A group is active only when its own status is enabled AND it has at least one
 * enabled option. A group whose every option has been disabled is treated as
 * disabled, even though its `status` is still `'enabled'`.
 *
 * @param {Object} variant - the variant group to check
 * @returns {Boolean}
 */
export default function checkIsVariantActive(variant) {
  if (!variant) return false;
  if (variant.status !== 'enabled') return false;

  return variant.options?.some(option => option.status === 'enabled') ?? false;
}
